import _                                                from 'underscore';
import React                                            from 'react';
import { useTogglableContentReducer }                   from './useTogglableContentReducer';
import { pageModalElementId, pageModalPortalElementId } from '../views/containers/PageModal';

export const useModal = () => {
	
	return useTogglableContentReducer( {
		modalId:  pageModalElementId,
		portalId: pageModalPortalElementId
	} );
};